export const LOCAL_STORAGE_KEY = {
  EMAIL_FIRST_LOGIN: 'email_first_login',
};
